<template>
  <FdText colorLightGrey fontSizeSmaller2 tag="span">Geomob &#169; {{ currentYear }}, by MONUNIVERT.FR</FdText>
</template>

<script>
import FdText from "@/flexdesign/Text";

export default {
  name: "GmbCopyright",

  components: {
    FdText,
  },

  props: {},

  data() {
    return {};
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
